import { useEffect, useState } from 'react';
import { eAlertType } from '../../../../../../providers/ToastProvider/Toast.enum.ts';
import { useToastContext } from '../../../../../../providers/ToastProvider/Toast.hook.ts';
import { useWorkspaceContext } from '../../../../../../providers/WorkspaceProvider/Workspace.context.ts';
import { ChatService } from '../../../../Chat.service.ts';
import { Change } from '../../../../Chat.types.ts';
import { tRecordsHook } from './Records.types.ts';
import { useModalsContext } from '../../../../../../providers/ModalsProvider/Modals.context.ts';
export default function useRecords(): tRecordsHook {
  const { addAlert } = useToastContext();
  const { currentWorkspace } = useWorkspaceContext();
  const { selectedLeadForChatModal } = useModalsContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [historyData, setHistoryData] = useState<Change[]>([]);

  async function getHistoryData() {
    setIsLoading(true);
    try {
      if (!currentWorkspace?.id || !selectedLeadForChatModal?.id) return;

      const response = await ChatService.getChatHistory({
        workspaceId: currentWorkspace.id,
        leadId: selectedLeadForChatModal.id,
      });

      if (response.data) {
        setHistoryData(response.data.changes);
      }
    } catch (error) {
      addAlert({
        type: eAlertType.ERROR,
        message:
          (error as Error)?.message ??
          'Error al obtener los datos históricos de tu lead',
      });
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      getHistoryData();
    })();
  }, [currentWorkspace?.id, selectedLeadForChatModal?.id]);

  return {
    historyData,
    isLoading,
    getHistoryData,
  };
}
